import { useState } from "react";
import { supabase } from "./supabase";
import stadiumImg from "./stadium.png";

export default function Onboarding({ user, onComplete }) {
  const [form, setForm] = useState({ name: "", city: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [focused, setFocused] = useState("");

  const handleSubmit = async () => {
    if (!form.name.trim()) {
      setError("Please enter your academy name");
      return;
    }
    setLoading(true);
    setError("");
    const { data, error } = await supabase
      .from("academies")
      .insert([{ user_id: user.id, name: form.name.trim(), city: form.city.trim() }])
      .select()
      .single();
    if (error) {
      setError(error.message);
    } else {
      onComplete(data);
    }
    setLoading(false);
  };

  return (
    <div style={s.container}>
      <div style={s.card}>

        {/* HEADER */}
        <div style={s.header}>
          <div style={s.logoRow}>
            <div style={s.logoIcon}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="#d4a017" strokeWidth="1.5" strokeLinejoin="round"/>
                <path d="M2 17l10 5 10-5" stroke="#d4a017" strokeWidth="1.5" strokeLinejoin="round"/>
                <path d="M2 12l10 5 10-5" stroke="#d4a017" strokeWidth="1.5" strokeLinejoin="round"/>
              </svg>
            </div>
            <span style={s.logoText}>THE COACH ROOM</span>
          </div>
          <h2 style={s.headerTitle}>Set up your Academy</h2>
          <p style={s.headerSub}>Tell us about your academy — takes 30 seconds</p>
        </div>

        <div style={s.progressBar}>
          <div style={s.progressFill} />
        </div>

        <div style={s.form}>
          <div style={s.welcomeBox}>
            <div style={s.welcomeIcon}>🏏</div>
            <div style={s.welcomeText}>Welcome, Coach! You're almost ready.</div>
          </div>

          <div style={s.field}>
            <label style={s.label}>Academy Name *</label>
            <input
              style={{
                ...s.input,
                borderColor: focused === "name" ? "#d4a017" : error ? "#e53e3e" : "#e8e0d0",
                boxShadow: focused === "name" ? "0 0 0 3px rgba(212,160,23,0.1)" : "none",
              }}
              placeholder="e.g. Sharma Cricket Academy"
              value={form.name}
              onChange={(e) => { setForm({ ...form, name: e.target.value }); setError(""); }}
              onFocus={() => setFocused("name")}
              onBlur={() => setFocused("")}
            />
          </div>

          <div style={s.field}>
            <label style={s.label}>City</label>
            <input
              style={{
                ...s.input,
                borderColor: focused === "city" ? "#d4a017" : "#e8e0d0",
                boxShadow: focused === "city" ? "0 0 0 3px rgba(212,160,23,0.1)" : "none",
              }}
              placeholder="e.g. Hyderabad"
              value={form.city}
              onChange={(e) => setForm({ ...form, city: e.target.value })}
              onFocus={() => setFocused("city")}
              onBlur={() => setFocused("")}
            />
          </div>

          {error && <div style={s.error}>{error}</div>}

          <button
            style={loading ? s.btnDisabled : s.btn}
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Setting up..." : "Launch My Academy →"}
          </button>

          <p style={s.note}>You can update these details later in Settings.</p>
        </div>
      </div>
    </div>
  );
}

const s = {
  container: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #0f1f14 0%, #1a3a1b 50%, #0f1f14 100%)",
    display: "flex", alignItems: "center", justifyContent: "center",
    padding: "2rem 1rem", fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    boxSizing: "border-box",
  },
  card: {
    background: "#faf7f0", width: "100%", maxWidth: "420px",
    boxShadow: "0 24px 64px rgba(0,0,0,0.4), 0 0 0 1px rgba(212,160,23,0.2)",
    overflow: "hidden", margin: "0 auto",
  },
  header: {
    background: `linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(10,20,10,0.88) 65%, rgba(250,247,240,1) 100%), url(${stadiumImg})`,
    backgroundSize: "cover", backgroundPosition: "center 30%",
    padding: "2rem 1.8rem 3rem", boxSizing: "border-box",
  },
  logoRow: { display: "flex", alignItems: "center", gap: "0.6rem", marginBottom: "2rem" },
  logoIcon: {
    width: "36px", height: "36px", background: "rgba(212,160,23,0.15)",
    border: "1px solid rgba(212,160,23,0.4)", borderRadius: "8px",
    display: "flex", alignItems: "center", justifyContent: "center",
  },
  logoText: { color: "white", fontSize: "0.75rem", fontWeight: "800", letterSpacing: "3px" },
  headerTitle: { color: "white", fontSize: "1.5rem", fontWeight: "700", margin: "0 0 0.3rem" },
  headerSub: { color: "rgba(255,255,255,0.55)", fontSize: "0.85rem", margin: 0, fontWeight: "300" },
  progressBar: { height: "3px", background: "#e8e0d0" },
  progressFill: { height: "100%", width: "75%", background: "linear-gradient(90deg, #1a3a1b, #d4a017)" },
  form: { padding: "1.8rem 1.8rem 2rem", boxSizing: "border-box" },
  welcomeBox: {
    display: "flex", alignItems: "center", gap: "0.8rem",
    background: "#f0fdf4", border: "1px solid #d4f1e0",
    padding: "0.9rem 1rem", marginBottom: "1.5rem",
  },
  welcomeIcon: { fontSize: "1.5rem", flexShrink: 0 },
  welcomeText: { fontSize: "0.85rem", fontWeight: "600", color: "#1a3a1b" },
  field: { marginBottom: "1.2rem" },
  label: { display: "block", fontSize: "0.7rem", fontWeight: "700", textTransform: "uppercase", letterSpacing: "1px", color: "#4a5568", marginBottom: "0.45rem" },
  input: {
    width: "100%", padding: "0.85rem 1rem", border: "1.5px solid #e8e0d0",
    fontSize: "0.95rem", fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    outline: "none", background: "white", color: "#1a1a1a",
    transition: "border-color 0.15s, box-shadow 0.15s", borderRadius: "0", boxSizing: "border-box",
  },
  btn: {
    width: "100%", padding: "1rem", background: "#1a3a1b", color: "white",
    border: "none", fontSize: "0.95rem", fontWeight: "700", cursor: "pointer",
    letterSpacing: "0.5px", marginBottom: "0.8rem", boxSizing: "border-box",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  btnDisabled: {
    width: "100%", padding: "1rem", background: "#a0aec0", color: "white",
    border: "none", fontSize: "0.95rem", fontWeight: "700", cursor: "not-allowed",
    letterSpacing: "0.5px", marginBottom: "0.8rem", boxSizing: "border-box",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  error: {
    background: "#fde8de", color: "#9b1c1c", padding: "0.7rem 0.9rem",
    fontSize: "0.8rem", fontWeight: "600", marginBottom: "1rem",
    borderLeft: "3px solid #e53e3e",
  },
  note: { textAlign: "center", fontSize: "0.72rem", color: "#a0aec0", fontStyle: "italic", margin: 0 },
};
